module.exports = __webpack_public_path__ + "43b14205fd72b01599c76a79b4b81680.svg";